import content from './components/common/views/content.html';

const config = function($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/dashboard');

     $stateProvider

        .state('login', {
            url: '/login',
            template: '<auth></auth>'
        })


        .state('dashboard', {
            url: '/dashboard',
            template: '<dashboard></dashboard>'
        })

        .state('sifranti', {
            abstract: true,
            url: "/sifranti",
            templateUrl: content,
        })

        .state('sifranti.grad', {
            url: '/grad',
            template: '<grad></grad>'
        })

        .state('sifranti.dijagnoza', {
            url: '/dijagnoza',
            template: '<dijagnoza></dijagnoza>'
        })

        .state('sifranti.djelatnik', {
            url: '/djelatnik',
            template: '<djelatnik></djelatnik>'
        })

        .state('sifranti.pacijent', {
            url: '/pacijent',
            template: '<pacijent></pacijent>'
        })

        .state('pacijent', {
            abstract: true,
            url: '/pacijent',
            templateUrl: content,
        })

        .state('pacijent.detail', {
            url: '/:id',
            template: '<detalji-pacijenta></detalji-pacijenta>'
        })

        .state('pregled', {
            url: '/pregled',
            template: '<pregled></pregled>'
        })

        .state('nalaz', {
            url: '/nalaz',
            template: '<nalaz></nalaz>'
        });

        ;
};


const run = function($rootScope, $state,  djangoAuth) {
    djangoAuth.initialize('/rest-auth', false);
    $rootScope.$on('$locationChangeSuccess', function () {
        djangoAuth.authenticationStatus(true).then(function () {
            return djangoAuth.profile();
        }).then(function (response) {
            $rootScope.user = response;
        }).catch(function () {
            $state.go('login');
        });
    });
};


run.$inject = ['$rootScope', '$state', 'djangoAuth'];
config.$inject = ['$stateProvider', '$urlRouterProvider'];

export {config};
export {run};



// WEBPACK FOOTER //
// ./app/config.js